import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../Form/FormBasicElements/Icon'
import InternalOrExternal from '../InternalOrExternal'

import {
  LinkComponentContainer,
  LinkComponentIconContainer,
  LinkComponentText
} from './components'

const LinkComponent = ({
  align,
  colorFill,
  colorStroke,
  colorText,
  disabled,
  display,
  fontBold,
  fontSize,
  iconAfter,
  iconBefore,
  inNewWindow,
  label,
  link,
  onClick,
  rotateIcons,
  type
}) => (
  <InternalOrExternal
    align={align}
    disabled={disabled}
    display={display}
    inNewWindow={inNewWindow}
    link={link}
    onClick={onClick}
    type={type}
  >
    <LinkComponentContainer
      colorText={colorText}
      fontBold={fontBold}
      fontSize={fontSize}
    >
      {iconBefore &&
        <LinkComponentIconContainer
          colorFill={colorFill}
          colorStroke={colorStroke}
          data-test='iconBeforeContainer'
          iconSize={fontSize}
          rotateIcons={rotateIcons}
        >
          <Icon
            data-test='iconBefore'
            icon={iconBefore}
          />
        </LinkComponentIconContainer>}

      {label &&
        <LinkComponentText>{label}</LinkComponentText>}

      {iconAfter &&
        <LinkComponentIconContainer
          colorFill={colorFill}
          colorStroke={colorStroke}
          data-test='iconAfterContainer'
          iconSize={fontSize}
          rotateIcons={rotateIcons}
        >
          <Icon
            data-test='iconAfter'
            icon={iconAfter}
          />
        </LinkComponentIconContainer>}
    </LinkComponentContainer>
  </InternalOrExternal>
)

export default LinkComponent

LinkComponent.propTypes = {
  align: PropTypes.oneOf(['center', 'left', 'right']),
  colorFill: PropTypes.oneOf(['pinkColorM', 'purpleColor', 'purpleColorM', 'purpleColorS', 'purpleColorXS', 'whiteColor']),
  colorStroke: PropTypes.oneOf(['pinkColorM', 'purpleColor', 'purpleColorM', 'purpleColorS', 'purpleColorXS', 'whiteColor']),
  colorText: PropTypes.oneOf(['pinkColorM', 'purpleColor', 'purpleColorM', 'purpleColorS', 'purpleColorXS', 'whiteColor']),
  disabled: PropTypes.bool,
  display: PropTypes.oneOf(['inline-flex']),
  fontBold: PropTypes.bool,
  fontSize: PropTypes.oneOf(['sizeXS', 'sizeS', 'sizeM', 'sizeL', 'sizeXL']),
  iconAfter: PropTypes.string,
  iconBefore: PropTypes.string,
  inNewWindow: PropTypes.bool,
  label: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  rotateIcons: PropTypes.oneOf(['90', '180']),
  type: PropTypes.oneOf(['external', 'internal', 'onClick'])
}

LinkComponent.defaultProps = {
  fontBold: false
}
